import Vue from 'vue'
import VueRouter from 'vue-router'
import erroRoutes from '@/modules/erro/erro.routes'
import lojaRoutes from '@/modules/loja/loja.routes'


Vue.use(VueRouter)

const routes = [
  ...erroRoutes,
  ...lojaRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router